const minPasswordLength = 8;

/**
 * Validates that the value is at least the minimum length.
 * @param value
 * @returns {null|string} Error message if validation fails, otherwise null.
 */
const hasMinimumLength = (value) =>
    (value && value.length >= minPasswordLength) ? null : `Password must be at least ${minPasswordLength} characters`;

/**
 * Validates that the value, if not blank, has at least one uppercase character. This validator supports unicode.
 * @param value
 * @returns {null|string} Error message if validation fails, otherwise null.
 */
const hasUpperCase = (value) =>
    (value === "" || /\p{Lu}+/u.test(value)) ? null : "Password must contain uppercase characters";

/**
 * Validates that the value, if not blank, has at least one numeric character.
 * @param value
 * @returns {null|string} Error message if validation fails, otherwise null.
 */
const hasNumbers = (value) =>
    (value === "" || /[0-9]+/.test(value)) ? null : "Password must contain numbers";

/**
 * Validates that the value, if not blank, has at least one symbol character.
 * @param value
 * @returns {null|string} Error message if validation fails, otherwise null.
 */
const hasSymbols = (value) =>
    (value === "" || /[!@#$%&'()*+",\\\-.\/:;<=>?]+/.test(value)) ? null : "Password must contain one of !@#$%&'()*+\",\\-./:;<=>?";

export {hasMinimumLength, hasUpperCase, hasNumbers, hasSymbols};
